import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../tornado/utils/sizes';
import { makeDefaultStylingContext } from '../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;

  return {
    alpha: 0,
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
  };
};
